export default "__VITE_ASSET__b7916690__"